import { mode_edit, mode_view } from '../../../../../../views/my-store/google-profile';

export default {
  title: 'Google-profiel',
  sections: {
    current_profile: {
      [mode_view]: 'Verbonden profiel',
      [mode_edit]: 'Verbonden profiel wijzigen',
    },
  },
  form: {
    google_places_id: {
      label: 'Google Maps-naam',
    },
    address: {
      label: 'Adres',
    },
    rating: {
      label: 'Beoordeling',
    },
    opening_hours: {
      label: 'Openingstijden',
    },
    phone_number: {
      label: 'Telefoonnummer',
    },
    pictures: {
      label: 'Afbeeldingen',
    },
  },
  labels: {
    no_place_connected: 'Dit restaurant heeft geen verbonden Google-profiel',
    fields_to_sync: 'Info synchroniseren van {{name}}',
  },
  buttons: {
    save: 'Opslaan',
    change: 'Wijzigen',
    cancel: 'Annuleren',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
};
